
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as feedCzRajSqu7_FDDJo1ZS2gVajINXx41WpnTn5ZSRRj8pgMeta } from "/vercel/path0/pages/feed.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as uploadhNjwpQD8R_45yF6ovGj8autjatYgr0qVXnismGTbGKda4Meta } from "/vercel/path0/pages/upload.vue?macro=true";
import { default as addshesGeGiTA7i3k9Y1kIy318bNKqZktIzvGa15TuSZXUMeta } from "/vercel/path0/pages/crows/add.vue?macro=true";
import { default as loginyS_635ZNODza5tjO9y_Kjsm5BWP5YDEqDSMaxBi9pVEMeta } from "/vercel/path0/pages/auth/login.vue?macro=true";
import { default as _91id_93__45zSiOvsnJhBlDdpmxuV9pFQF9RWNkzvZ3tRbOooIXMMeta } from "/vercel/path0/pages/share/[id].vue?macro=true";
import { default as indexoCwohuAkqfQVn6XjBB_45N0qRYrkR8AjoEpdYCxJI3suYMeta } from "/vercel/path0/pages/crows/index.vue?macro=true";
import { default as _91name_93rLk6a1bLsEd9XpySyMeHI5v74y1ZwwQ74DJOnHhbs4sMeta } from "/vercel/path0/pages/crows/[name].vue?macro=true";
export default [
  {
    name: "feed",
    path: "/feed",
    meta: feedCzRajSqu7_FDDJo1ZS2gVajINXx41WpnTn5ZSRRj8pgMeta || {},
    component: () => import("/vercel/path0/pages/feed.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "upload",
    path: "/upload",
    meta: { ...(uploadhNjwpQD8R_45yF6ovGj8autjatYgr0qVXnismGTbGKda4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/upload.vue")
  },
  {
    name: "crows-add",
    path: "/crows/add",
    meta: { ...(addshesGeGiTA7i3k9Y1kIy318bNKqZktIzvGa15TuSZXUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/crows/add.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginyS_635ZNODza5tjO9y_Kjsm5BWP5YDEqDSMaxBi9pVEMeta || {},
    component: () => import("/vercel/path0/pages/auth/login.vue")
  },
  {
    name: "share-id",
    path: "/share/:id()",
    meta: _91id_93__45zSiOvsnJhBlDdpmxuV9pFQF9RWNkzvZ3tRbOooIXMMeta || {},
    component: () => import("/vercel/path0/pages/share/[id].vue")
  },
  {
    name: "crows",
    path: "/crows",
    meta: { ...(indexoCwohuAkqfQVn6XjBB_45N0qRYrkR8AjoEpdYCxJI3suYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/crows/index.vue")
  },
  {
    name: "crows-name",
    path: "/crows/:name()",
    meta: { ...(_91name_93rLk6a1bLsEd9XpySyMeHI5v74y1ZwwQ74DJOnHhbs4sMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/crows/[name].vue")
  }
]